import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Chat from 'components/shared/chat/Chat';

class RfiQuestionNotes extends Component {
  static propTypes = {
    questionKey: PropTypes.string.isRequired,
    question: PropTypes.shape({}).isRequired,
    loadQuestionNotes: PropTypes.func.isRequired,
    createQuestionNote: PropTypes.func.isRequired,
  };

  loadNotes = () => {
    const { questionKey, question, loadQuestionNotes } = this.props;
    return loadQuestionNotes(questionKey, question);
  };

  buildNote = (newNote) => {
    return {
      note: newNote.content ? newNote.content : '',
      images: newNote.images ? newNote.images : [],
      documents: newNote.documents ? newNote.documents : [],
    };
  };

  handleSubmit = (newNote) => {
    const { questionKey, question, createQuestionNote } = this.props;
    return createQuestionNote(
      questionKey,
      question.id,
      this.buildNote(newNote)
    );
  };

  render() {
    const { question } = this.props;
    return (
      <Chat
        name="RFI"
        notes={question.notes}
        loadChat={this.loadNotes}
        handleSubmit={this.handleSubmit}
      />
    );
  }
}

export default connect()(RfiQuestionNotes);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-rfi-log/RfiQuestionNotes.js